import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}',
  items: [
    // 店铺销售表
    { key: 'getChannelorderReport', url: '/shop/channel-order-report', method: 'POST' },
    // 获取指定仓库下拉列表以供单选(旧)   get /v1/{organizationId}/online/shop/shopifyLocations/{account}
    { key: 'getShopifyLocationsList', url: '/online/shop/shopifyLocations/{account}', method: 'get' },
    // 获取指定仓库下拉列表以供单选(新)   get /v1/{organizationId}/online/shop/getLocations/{account
    { key: 'getShopifyGetLocations', url: '/online/shop/getLocations/{account}', method: 'get' },
    // Shopify店铺获取备注(旧)   POST /v1/{organizationId}/online/shop/shopifyStoreVerify
    { key: 'getShopifyRemarks', url: '/online/shop/shopifyStoreVerify', method: 'POST' },
    // Shopify LIXING 店铺获取备注(新)   post /v1/{organizationId}/online/shop/storeVerify
    { key: 'getStoreVerifyRemarks', url: '/online/shop/storeVerify', method: 'POST' },

    // 物流下单 查询店铺开启的物流公司   get /v1/{organizationId}/logistics/config/queryShopOpenLogistics
    { key: 'getShopOpenLogistics', url: '/logistics/config/queryShopOpenLogistics?shopCode={shopCode}', method: 'get' },
  ],
};
export default {
  ...generate(config),
};
